import React from 'react';

import Modal from 'react-bootstrap/Modal';

const Text2BoolConverter = (props) => {
    let params = { }

    if (props.field) {
        if (props.field.dataset.params) {
            params = JSON.parse(decodeURIComponent(escape(atob(props.field.dataset.params))))
        }
    }

    const show = props.field && props.field.dataset.datatype === "text"

    return <Modal show={show} onHide={() => props.onHide()} className="alert">
        <Modal.Header closeButton>
            <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            true:<input type="text" className="form-control" placeholder="true" value={params.trueValue} onChange={(e) => { params.trueValue = e.target.value; props.onParamsUpdated(params) }} />
            false:<input type="text" className="form-control" placeholder="false or empty" value={params.falseValue} onChange={(e) => { params.falseValue = e.target.value; props.onParamsUpdated(params) }} />
        </Modal.Body>
        <Modal.Footer>
            <button type="button" className="submit-btn" data-dismiss="modal" onClick={props.onHide}>{props.buttonText}</button>
        </Modal.Footer>
    </Modal>
}

export default Text2BoolConverter